

export const themePageQuery = `query ThemePages(
  $after: Cursor
  $before: Cursor
  $first: Int
  $last: Int
  $orderBy: ThemePageOrder
  $themeID: ID!
  $where: ThemePageWhereInput
  $themePageMetasWhere: ThemePageMetaWhereInput,
  $themePageMetasFirst: Int
){
  themePages(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    themeID: $themeID
    where: $where
  ) {
    edges {
      cursor
      node {
        ...ThemePageSelect
        themePageMetas(where: $themePageMetasWhere, first: $themePageMetasFirst) {
          edges {
            node {
              key
              value
              id
              createdAt
              updatedAt
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}


fragment ThemePageSelect on ThemePage {
  id
  name
  description
  type
  default
  isGlobal
  isMobile
  status
  sectionPosition
  splitPercentage
  themeStyle {
    id
    data
  }
  themePageOnlineStoreData {
    id
    onlineStoreObjectBaseIDs
  }
  theme {
    thumbnail
  }
  handle
  createdAt
  updatedAt
}

`;

export const themesQuery = `
  query themes($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ThemeOrder, $where: ThemeWhereInput) {
    themes(
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      where: $where
    ) {
      edges {
        cursor
        node {
          ...ThemeSelect
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
  fragment ThemeSelect on Theme {
    createdAt
    id
    isGlobal
    isPublished
    name
    thumbnail
    updatedAt
  }
`;

export const themePageMutation = `mutation ThemePageUnPublish($themeId: ID!, $ids: [ID!]) {
  themePageUnPublish(themeID: $themeId, ids: $ids)
}`;

export const themePageCount = `query themePageLimitation($appType: AppType!) {
  themePageLimitation(appType: $appType) {
    publishedPagesCount
    publishedStaticPagesCount
    publishedProductPagesCount
    publishedCollectionPagesCount
    publishedArticlePagesCount
    publishedIndexPagesCount

    maximumPublishedPages
    maximumPublishedStaticPages
    maximumPublishedProductPages
    maximumPublishedCollectionPages
    maximumPublishedArticlePages
  }
}`;

export const themePageUpdate = `mutation themePageUpdate($id: ID!, $input: UpdateThemePageInput!) {
  themePageUpdate(id: $id, input: $input) {
    createdAt
    default
    description
    id
    name
    splitPercentage
    status
    type
    updatedAt
  }
}`

export const themePageDelete = `mutation themePageDelete($id: ID!) {
  themePageDelete(id: $id)
}`

export const themePagesGlobal = `
  query themePagesGlobal(
    $after: Cursor
    $before: Cursor
    $first: Int
    $last: Int
    $orderBy: ThemePageOrder
    $where: ThemePageWhereInput
  ) {
    themePagesGlobal(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, where: $where) {
      edges {
        cursor
        node {
          ...ThemePagesGlobalSelect
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }

  fragment ThemePagesGlobalSelect on ThemePage {
    createdAt
    default
    description
    id
    isGlobal
    name
    sectionPosition
    splitPercentage
    status
    type
    updatedAt
    themePageMetas {
      edges {
        node {
          key
          value
        }
      }
    }
  }
`;

export const themePageDuplicate = `
  mutation Mutation($themePageDuplicateId: ID!, $themeId: ID!) {
    themePageDuplicate(id: $themePageDuplicateId, themeID: $themeId) {
      id
      name
      type
    }
  }
`
